module.exports = __webpack_public_path__ + "static/media/XD.b4660102.pdf";